import { ArrowUpward, ArrowDownward } from '@mui/icons-material';
import { Button, IconButton, TableCell, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import Global, { getCachedData, isAuthenticated, isBusinessAccountType, setCachedData } from '../util/Global';
import { createContext, useContext, useEffect, useState } from 'react';
import { GlobalData } from '../util/GlobalData';
import React from 'react';
import { QrReader } from 'react-qr-reader';
import jsQR from 'jsqr';
import { useRef, useImperativeHandle, forwardRef } from 'react';
import QRCode from 'qrcode';
import InfoIcon from '@mui/icons-material/Info';
import { FR, GB, TN, IT, ES, TR, DE } from 'country-flag-icons/react/3x2';
import { LanguageSelectorComponent } from "./LanguageSelector";
import { CurrencySelectorComponent } from "./CurrencySelector";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { LanguageContext } from '../util/LanguageSelector';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { DeliveryCountrySelectorComponent } from './DeliveryCountrySelector';
import { LoaderComponent } from '../util/Loader';
import { Countries } from '../util/countries';

export const QrScanner = forwardRef(({ onScanSuccess, onError }, ref) => {
    const [isCameraActive, setIsCameraActive] = useState(false);
    const fileInputRef = useRef(null);

    // Handle scanning from camera
    const handleScan = (data) => {
        if (data) {
            onScanSuccess(data);
            setIsCameraActive(false);
        }
    };

    const handleError = (err) => {
        console.error(err);
        if (onError) onError("Error scanning QR code");
    };

    // Start the camera scan by activating `QrReader`
    const startCameraScan = () => {
        setIsCameraActive(true); // Activate camera
    };

    // Handle file upload
    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const img = new Image();
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.drawImage(img, 0, 0, img.width, img.height);

                    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    const code = jsQR(imageData.data, canvas.width, canvas.height);



                    if (code && code.data != "https://qrco.de/bfMQLu") {
                        onScanSuccess(code.data);
                        setIsCameraActive(false)
                    } else {
                        if (onError) onError('No QR code found in the image');
                    }
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(file);
        }
    };

    const triggerFileUpload = () => {
        setIsCameraActive(false)
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    useImperativeHandle(ref, () => ({
        startCameraScan,
        triggerFileUpload
    }));

    return (
        <div>
            {isCameraActive && (
                <QrReader
                    delay={300}
                    onError={handleError}
                    onScan={handleScan}
                    style={{ width: '100%' }}
                />
            )}
            <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={handleFileUpload}
                style={{ display: 'none' }}
            />
        </div>
    );
});






export function QrCodeImageGenerator({ text }) {
    const [qrCodeImage, setQrCodeImage] = useState('');

    useEffect(() => {
        if (text) {
            // Generate QR code when text changes
            QRCode.toDataURL(text, { errorCorrectionLevel: 'H' })
                .then((url) => {
                    setQrCodeImage(url);
                })
                .catch((err) => {
                    console.error('Error generating QR Code:', err);
                });
        }
    }, [text]);

    if (qrCodeImage)
        return (
            <img src={qrCodeImage} alt="Generated QR Code" />
        );
}




export function SortTabCell({ title, onClick, sortColumn, sortDirection, label }) {
    return (
        <TableCell>
            <div onClick={() => onClick(label)} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontWeight: "bold" }}>
                {title}
                {sortColumn === label && (sortDirection === 'asc' ? <ArrowUpward /> : <ArrowDownward />)}
            </div>
        </TableCell>
    )
}



export function getUserFullName(t, user) {

    return (
        <>
            <Typography color={"primary"} sx={{ fontWeight: "bold" }}>
                {isBusinessAccountType(user.compte) ? user.entreprise?.nom : ""}
            </Typography>
            {isBusinessAccountType(user.compte) ? "(" : ""} {user.prenom} {user.nom} {isBusinessAccountType(user.compte) ? ")" : ""}
            < Typography color={"secondary"} sx={{ fontWeight: "bold" }}>
                {user.id == localStorage.getItem("id") ? "(" + t("me") + ")" : ""}
            </Typography >
        </>
    )
}


export function getSavedDeliveryCountry() {
    const selected_delivery_country = getCachedData("selected_delivery_country", false)

    return selected_delivery_country ? selected_delivery_country : (isAuthenticated() ? localStorage.getItem("country") : "France")
}

export const getSavedCurrency = () => {
    const selected_currency = getCachedData("selected_currency", false)

    return selected_currency ? selected_currency : "EUR"
}

export const getSavedCurrencyRates = async () => {
    const CONVERSION_RATES_URL = Global.backend + "/index.php/conversion-rates"


    const currencyRates = JSON.parse(getCachedData("currency_rates", false))
    const currencyExpireTimestap = getCachedData("currency_expire", false)  // seconds


    if (!currencyRates || currencyExpireTimestap < Math.round((new Date().getTime()) / 1000)) {
        const response = await axios.post(CONVERSION_RATES_URL, { currencies: Object.keys(GlobalData.currency) })
        const { conversionRates, expireTime } = response.data
        setCachedData("currency_rates", JSON.stringify(conversionRates), false)
        setCachedData("currency_expire", expireTime, false)

        return conversionRates
    }

    return currencyRates
}

export const CurrencyContext = createContext()
export const DeliveryCountryContext = createContext()


export function DeliveryCountry({ children }) {
    const [deliveryCountry, setdeliveryCountryState] = useState(getSavedDeliveryCountry())
    const [countries, setcountries] = useState([])
    const [isLoading, setisLoading] = useState(true)

    useEffect(() => {
        setcountries(Countries.map((country) => ({ name: country.country, value: country.country })))
        setisLoading(false)
    }, [])




    function setdeliveryCountry(value) {
        setdeliveryCountryState(value)
        setCachedData("selected_delivery_country", value, false)
    }

    return (
        <DeliveryCountryContext.Provider value={{ deliveryCountry, setdeliveryCountry, countries }}>
            <LoaderComponent isLoading={isLoading}>
                {children}
            </LoaderComponent>
        </DeliveryCountryContext.Provider>
    )
}

export function Currency({ children }) {
    const [currency, setCurrencyState] = useState(getSavedCurrency())
    const [conversionRate, setconversionRate] = useState({
        "EUR": {}
    })
    const [isLoading, setisLoading] = useState(true)


    useEffect(() => {
        getSavedCurrencyRates().then((data) => {
            setconversionRate(data)
        }).catch((err) => {


        }).finally(() => {
            setisLoading(false)
        })
    }, [])



    function setCurrency(value) {
        setCurrencyState(value)
        setCachedData("selected_currency", value, false)
    }


    function getCurrencyPrice(price, baseCurrency = "EUR", toCurrency = currency) {
        if (!conversionRate[baseCurrency]) {
            return price
        }

        if (toCurrency == baseCurrency) {
            return Number(Number(price).toFixed(2))
        }



        return Number((conversionRate[baseCurrency][toCurrency] * Number(price)).toFixed(2))
    }

    return (
        <CurrencyContext.Provider value={{ currency, setCurrency, getCurrencyPrice }}>
            <LoaderComponent isLoading={isLoading}>
                {children}
            </LoaderComponent>
        </CurrencyContext.Provider>
    )
}





export function filterSaleByRetailer(sale, getCurrencyPrice, userId = localStorage.getItem("id")) {
    const filteredProducts = []
    let filteredTotal = 0


    sale.produitVendus.map((product) => {
        if (product.fournisseur.id == userId) {
            filteredProducts.push(product)

            filteredTotal += getCurrencyPrice(product.totale, product.currency, sale.currency) + product.deliveryFee
        }
    })


    sale.produitVendus = filteredProducts
    sale.totale = filteredTotal

    return sale
}



export function HintComponent({ text }) {
    return (
        <Tooltip title={text}>
            <IconButton color="primary">
                <InfoIcon />
            </IconButton>
        </Tooltip>
    )
}



export function LanguageFlag({ language }) {

    const flagMap = {
        fr: <FR width="20" alt="French" style={{ marginRight: '8px' }} />,
        en: <GB width="20" alt="English" style={{ marginRight: '8px' }} />,
        tn: <TN width="20" alt="Tunisian" style={{ marginRight: '8px' }} />,
        it: <IT width="20" alt="Italian" style={{ marginRight: '8px' }} />,
        es: <ES width="20" alt="Spanish" style={{ marginRight: '8px' }} />,
        tr: <TR width="20" alt="Turkish" style={{ marginRight: '8px' }} />,
        de: <DE width="20" alt="German" style={{ marginRight: '8px' }} />,
    }

    return flagMap[language]
}




export function HeaderLanguageCurrency({ blackStyle }) {
    const { currency, setCurrency } = useContext(CurrencyContext)
    const { language, setLanguage } = useContext(LanguageContext)
    const { deliveryCountry, setdeliveryCountry, countries } = useContext(DeliveryCountryContext)
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'))
    const { t } = useTranslation()

    return (
        <div>
            <Button
                variant="outlined"
                onClick={() => { setIsDialogOpen(true) }}
                sx={{
                    borderColor: (isSmallScreen || blackStyle) ? '#000' : '#fff',
                    color: (isSmallScreen || blackStyle) ? '#000' : '#fff',
                    fontWeight: "bold",
                    '&:hover': {
                        borderColor: (isSmallScreen || blackStyle) ? '#000' : '#fff',
                    },
                }}
                endIcon={<ArrowDropDownIcon />}
            >
                <LanguageFlag language={language} /> {language.toLocaleUpperCase()} - {currency}
            </Button>

            <Dialog open={isDialogOpen} onClose={() => { setIsDialogOpen(false) }}>
                <DialogTitle>{t("languageAndCurrencySettings")}</DialogTitle>
                <DialogContent>
                    <ul style={{ listStyleType: "none", padding: 0 }}>
                        <section style={{ marginBottom: "20px" }}>
                            <h3 style={{ fontSize: "1.2rem", marginBottom: "10px" }}>{t("languageSettings")}</h3>
                            <p style={{ marginBottom: "10px", fontSize: "1rem" }}>
                                {t("selectLanguageDesc")}
                            </p>
                            <LanguageSelectorComponent fullWidth={true} blackStyle={true} language={language} handleLanguageChange={(e) => setLanguage(e.target.value)} />
                        </section>


                        <section style={{ marginBottom: "20px" }}>
                            <h3 style={{ fontSize: "1.2rem", marginBottom: "10px" }}>{t("deliverySettings")}</h3>
                            <p style={{ marginBottom: "10px", fontSize: "1rem" }}>
                                {t("selectDeliverySettings")}
                            </p>
                            <DeliveryCountrySelectorComponent fullWidth={true} blackStyle={true} deliveryCountry={deliveryCountry} countries={countries} handleChange={(value) => setdeliveryCountry(value)} />
                        </section>

                        <section>
                            <h3 style={{ fontSize: "1.2rem", marginBottom: "10px" }}>{t("currencySettings")}</h3>
                            <p style={{ marginBottom: "10px", fontSize: "1rem" }}>
                                {t("selectCurrencyDesc")}
                            </p>
                            <CurrencySelectorComponent fullWidth={true} blackStyle={true} currency={currency} handleCurrencyChange={(e) => setCurrency(e.target.value)} />
                            <p style={{ fontSize: "1rem" }}>
                                {t("note.1")} <strong>{GlobalData.currency[currency]} - {currency}</strong> {t("note.2")}
                            </p>
                        </section>
                    </ul>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setIsDialogOpen(false) }} variant='contained'>
                        {t("close")}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}